import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useStyles } from './styles';

const ChoiceModal = (props) => {
	const { classes } = useStyles();
	const { onClose, show, title="ChoiceModal", text, actions } = props;

	return (
		<Dialog maxWidth="md" open={!!show} onClose={onClose} className={classes.root}>
			<DialogTitle>
				<Box display="flex" flexDirection="column" justifyContent="left">
					<Typography variant="h3">{title}</Typography>
				</Box>
			</DialogTitle>
			<DialogContent>
				<Typography color="secondary" variant="body1" className={classes.text}>
					{text}
				</Typography>
			</DialogContent>
			<DialogActions className={classes.actionButtons}>
				{actions}
			</DialogActions>
		</Dialog>
	);
};

export default ChoiceModal;
